import React, { Component } from 'react';
import SitesSelect from '../../common/SitesSelect';
import UserDefinedFieldEditor from '../../common/UserDefinedFieldEditor';
import { HttpRequestService } from '../../services/HttpRequestService';

class CategoryInformation extends Component {
    constructor(props) {
        super(props);
        this.http = new HttpRequestService();
        this.state = {
            name: props.category ? props.category.name : "",
            site: props.category && props.category.site.key ? props.category.site.key : 0,
            summary: props.category ? props.category.summary : "",
            description: props.category ? props.category.description : "",      
            sortOrder: props.category ? props.category.sortOrder : 0,       
            userDefinedFields: []
        }

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleSiteChange = this.handleSiteChange.bind(this);
        this.handleSummaryChange = this.handleSummaryChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);  
        this.handleSortOrderChange = this.handleSortOrderChange.bind(this);
        this.getUserDefinedFields = this.getUserDefinedFields.bind(this);      
        this.notifyChange();
    }

    componentDidMount() {
        this.getUserDefinedFields();
    }

    getUserDefinedFields() {
        var params = {
            entity: "Category"
        }
        this.http.get("/api/Admin/GetUserDefinedFieldsForEntity", params).then(data => {
            // match values with fields
            for (var i = 0; i < data.length; i++) {
                if (this.props.category && this.props.category.userDefinedFields) {
                    var categoryFieldValue = this.props.category.userDefinedFields.find(f => f.userDefinedFieldID === data[i].userDefinedFieldID);
                    if (data[i].selection === "Single") {
                        data[i].value = categoryFieldValue ? categoryFieldValue.userDefinedFieldOptionID : -1;
                    }
                    else {
                        data[i].value = categoryFieldValue ? categoryFieldValue.userDefinedFieldOptionIDs : [];
                    }
                }
                else {
                    if (data[i].selection === "Single") {
                        data[i].value = -1;
                    }
                    else {
                        data[i].value = [];
                    }
                }
            }
            this.setState({ userDefinedFields: data }, this.notifyChange);
        });
    }

    handleNameChange(e) {
        this.setState({
            name: e.target.value
        }, this.notifyChange);
    }

    handleSiteChange(value) {
        this.setState({
            site: value
        }, this.notifyChange);
    }

    handleSummaryChange(e) {
        this.setState({
            summary: e.target.value
        }, this.notifyChange);
    }

    handleDescriptionChange(e) {
        this.setState({
            description: e.target.value
        }, this.notifyChange);
    }
    
    handleSortOrderChange(e) {
        this.setState({
            sortOrder: e.target.value
        }, this.notifyChange);
    } 

    handleFieldChange(index, e) {
        var userDefinedFields = this.state.userDefinedFields;
        userDefinedFields[index].value = e;
        this.setState({
            userDefinedFields: userDefinedFields
        }, this.notifyChange);
    }

    notifyChange() {
        if (this.props.onChange) {
            this.props.onChange(this.state);
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="form-row">
                    <div className="form-group col-md-6">
                        <label>Name</label>
                        <input type="text" value={this.state.name} onChange={this.handleNameChange} className="form-control" />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Site</label>
                        <SitesSelect disabled={this.props.updating} value={this.state.site} onChange={this.handleSiteChange} className="form-control"></SitesSelect>
                    </div>
                    <div className="form-group col-md-12">
                        <label>Summary</label>
                        <input type="text" value={this.state.summary} onChange={this.handleSummaryChange} className="form-control" />
                    </div>
                    <div className="form-group col-md-12">
                        <label>Description</label>
                        <textarea rows={6} className="form-control" value={this.state.description} onChange={this.handleDescriptionChange}></textarea>
                    </div>
                    <div className="form-group col-md-12">
                        <label>Sort Order</label>
                        <input type="text" value={this.state.sortOrder} onChange={this.handleSortOrderChange} className="form-control" />
                    </div>
                    {this.state.userDefinedFields.map((field, index) =>
                        <div key={field.userDefinedFieldID} className="form-group col-md-12">
                            <UserDefinedFieldEditor field={field} value={field.value} onChange={(e) => this.handleFieldChange(index, e)}></UserDefinedFieldEditor>
                        </div>
                    )}                   
                </div>
            </React.Fragment>
        );
    }
}

export default CategoryInformation
